{
  "includedProducts": {
    "seatWifi": {
      "text": "{seatType} {seatNumber} + Full flight Stream package",
      "title": "Seat + Wifi"
    },
    "bundle": {
      "title": "Combos"
    }
  },
  "services": {
    "bundle": {
      "amount": {
        "seatWifi": "{amount} x Seat + Internet access"
      },
      "summary-title": "Combos",
      "seatWifi": "Seat + Internet access"
    }
  },
  "notifications": {
    "tripContainsTrain": {
      "link": {
        "url": "#"
      }
    }
  }
}
